import script from "./MagicLinkRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./MagicLinkRequest.vue?vue&type=script&setup=true&lang=js"

import "./MagicLinkRequest.vue?vue&type=style&index=0&id=af64fae2&lang=scss"

const __exports__ = script;

export default __exports__